import { atom } from "recoil";

export const authAtom = atom({
  key: "authAtom",
  default: {
    isLoggedIn: false,
    username: null,
    name: null,
  },
});

export const registerAtom = atom({
  key: "registerAtom",
  default: {
    username: null, // 사용자 아이디 = email
    password: null, // 비밀번호
    phone: null, // 핸드폰번호
    gender: null, // 성별
    birth: null, // 생년월일
    name: null, // 이름
    smsMessage: null, // sms 인증 api로부터 온 에러 메세지
    emailMessage: null, // email 인증 api로부터 온 에러 메세지
  },
});

export const findAccountAtom = atom({
  key: "findAccount",
  default: {
    phone: null,
    authenticationNumber: null,
    username: null,
    smsMessage: null,
    newPassword: null,
  },
});
